import { push } from "connected-react-router";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import jwt_decode from "jwt-decode";
import { useTwoFactorTimer } from "../../../hooks/useTwoFactorTimer";
import { twoFactorTimerUtils } from "../../../utils/twoFactorTimer";

export default function LoginHandler({
  children = <div>Redirecting ...</div>,
}) {
  const dispatch = useDispatch();
  const { loginPayload } = useSelector((state) => ({
    loginPayload: state.login.loginPayload,
  }));

  const { enqueueSnackbar } = useSnackbar();
  const { startTimer, clearTimer, handleTimeout } = useTwoFactorTimer();

  useEffect(() => {
    console.log("loginPayload", loginPayload);

    // Check for expired 2FA session on mount
    if (
      twoFactorTimerUtils.hasActiveTimer() &&
      twoFactorTimerUtils.isExpired()
    ) {
      console.log("Two-factor session expired on mount");
      handleTimeout();
      return;
    }

    if (!loginPayload || Object.keys(loginPayload).length === 0) {
      return;
    }

    if (loginPayload.error || !loginPayload.data) {
      const loginResult = loginPayload?.data;
      if (loginResult?.isVerifyEmail) {
        enqueueSnackbar(`${loginPayload.message}`, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(`Login failed. ${loginPayload.message}`, {
          variant: "error",
        });
      }
      dispatch(push("/login"));
      return;
    }

    const loginResult = loginPayload.data;
    const twoFactorLoginResult = loginPayload.data;
    const token = loginResult?.autho_token;
    console.log("loginResult", loginResult);

    if (!token && twoFactorLoginResult?.two_factor_auth_enabled) {
      // Only start timer if one doesn't already exist
      if (!twoFactorTimerUtils.hasActiveTimer()) {
        console.log("Starting two-factor authentication flow with timer");
        startTimer();
      } else {
        console.log(
          "Two-factor timer already exists, resuming from current time"
        );
      }

      dispatch({
        type: "SET_LOGIN_RESPONSE_FOR_TWOFACTOR",
        payload: loginPayload?.data,
      });
      dispatch(push("/two_factor_authentication"));
      return;
    }

    if (!token) {
      enqueueSnackbar(`Login failed. Missing autho_token.`, {
        variant: "error",
      });
      dispatch(push("/login"));
      return;
    }

    // Successful login - clear any existing 2FA timer
    console.log("Login successful, clearing two-factor timer");
    clearTimer();

    // Active current app
    let decodedUser = jwt_decode(token);
    if (decodedUser && decodedUser["user-data"]) {
      dispatch({ type: "SET_CURRENT_USER", user: decodedUser["user-data"] });
    }
    dispatch({ type: "SET_AUTH_TOKEN", token: loginPayload.data.autho_token });
    dispatch(push("/publicInstrument"));
  }, [
    loginPayload,
    dispatch,
    enqueueSnackbar,
    startTimer,
    clearTimer,
    handleTimeout,
  ]);

  return <>{children}</>;
}
